import React, {
  useState,
  useCallback,
  useReducer,
  useEffect,
  useRef,
  useMemo,
} from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";

import { I18n } from "aws-amplify/utils";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Container,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import OrganizationalChart from "./chart/StaticOrganizationalChart";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { hrGetFilters, hrGetUserManager } from "./apiService";
import { useLocation, useSearchParams } from "react-router-dom";
import ChartFromSimulation from "./chart/chartFromSimulation";
import { Filter, Filter3, FilterList, Search } from "@mui/icons-material";
import FilterModal from "./chart/modal/filterModal";
import { loadSimulationData, saveOrgData } from "./indexedDbUtils";
import Chat from "layouts/chat/index.js";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CircleIcon from "@mui/icons-material/Circle";
import Draggable from "react-draggable";

const reducer = (lastState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...lastState,
        searchFetched: false,
      };

    case "DATA_RECEIVED":
      const audit = action.value;
      if (Array.isArray(audit)) {
        audit.forEach((element) => {
          if (typeof element.timestamp === "number") {
            element.timestamp = dayjs(element.timestamp).format(
              "YYYY-MM-DD HH:mm"
            );
          }
        });
        return {
          audit: audit,
          fetched: true,
          searchFetched: true,
          lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        };
      }
      break;

    default:
      return lastState;
  }
};

function Dashboard() {
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
    searchFetched: false,
    lastUpdate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  /* -------------------------------------------------------- HOOKS -------------------------------------------*/
  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));

  const [language, setLanguage] = useState(
    // localStorage.getItem("language") || "en"
    "en"
  );
  const location = useLocation();
  const isSimulation = location.state?.fromSimulation === true;

  // const [dataSimulation, setDataSimulation]=useState(null);
  // useEffect(()=>{
  //   const fetchSimulation=async()=>{
  //     if(isSimulation){
  //       const stored=await loadSimulationData();
  //       setDataSimulation(stored||[]);
  //     }else{
  //       setDataSimulation(null)
  //     }
  //   }
  //   fetchSimulation();
  // }, [isSimulation])

  //qualora volessi recuperare simulationId dall'url
  const [searchParams] = useSearchParams();
  const simulationId = searchParams.get("simulationId");

  const chartRef = useRef(null); //ref per il grafico
  const [profile, setProfile] = useState([]);

  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [errorMotivation, setErrorMotivation] = useState("");
  // const [activeFilters, setActiveFilters] = useState(new Set());
  const [botResponse, setBotResponse] = useState(null);

  /* -------------------------------------------------------- FILTERS -------------------------------------------*/
  const [isMinimized, setIsMinimized] = useState(true);
  const [filters, setFilters] = useState({
    country: [],
    legal_entity: [],
    manager_email: [],
    grade: [],
    job_function: [],
    job_family: [],
    person_types: [],
    departments: [],
    worker_types: [],
    ceo_h_levels: [],
  }); //stato per i filtri

  const handleDependentFilterOptions = (optionsObj, dependsOn) => {
    const baseFilter = filters[dependsOn]; // Should be an array
    let dependentOptions = [];
    if (baseFilter.length > 0) {
      for (let baseOption of baseFilter) {
        const options = optionsObj[baseOption]; // Should be an array
        console.log(options);
        console.log(Array.isArray(options));
        Array.isArray(options)
          ? (dependentOptions = [...dependentOptions, ...options])
          : (dependentOptions = [...dependentOptions]);
      }
      // dependentOptions = dependentOptions.sort();
      dependentOptions = [...new Set(dependentOptions)];
    }
    // dependentOptions = [...new Set(dependentOptions)];
    return dependentOptions;
  }; //Set options for the dependent fields (multiple values)

  const [legalEntities, setLegalEntities] = useState({});
  const [jobFamilies, setJobFamilies] = useState({});
  // const legalEntitiesOptions = Array.isArray(legalEntities[filters.country])
  //   ? legalEntities[filters.country]
  //   : [];

  const legalEntitiesOptions = handleDependentFilterOptions(
    legalEntities,
    "country"
  );
  // const jobFamiliesOptions = Array.isArray(jobFamilies[filters.job_function])
  //   ? jobFamilies[filters.job_function]
  //   : [];

  const jobFamiliesOptions = handleDependentFilterOptions(
    jobFamilies,
    "job_function"
  );
  const [countries, setCountries] = useState([]);
  const [managers, setManagers] = useState([]);
  const [ceoLevels, setCeoLevels] = useState([]);
  const [personTypes, setPersonTypes] = useState([]);
  const [grades, setGrades] = useState([]);

  const [jobFunctions, setJobFunctions] = useState([]);

  const [departments, setDepartments] = useState([]);
  const [workerTypes, setWorkerTypes] = useState([]);
  const [periodList, setPeriodList] = useState([]);
  const [loggedUserData, setLoggedUserData] = useState({});

  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [selectedManager, setSelectedManager] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedLegalEntity, setSelectedLegalEntity] = useState([]);
  const [selectedJobFunction, setSelectedJobFunction] = useState([]);
  const [selectedJobFamily, setSelectedJobFamily] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedCeoLevel, setSelectedCeoLevel] = useState([]);
  const [selectedWorkerTypes, setSelectedWorkerTypes] = useState([]);
  const [selectedPersonTypes, setSelectedPersonTypes] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState([]);

  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const [filtersFromBot, setFiltersFromBot] = useState(false);
  const [layerSpan, setLayerSpan] = useState({
    layer: null,
    span: null,
  });

  // const sortOptionsWithSelectFirst = (options, selectedValues, isOptionAnObj=false) => {
  //   return [...options].sort((a, b) => {

  //     if (isOptionAnObj === true) {

  //     }
  //     const aSelected = selectedValues.includes(a);
  //     const bSelected = selectedValues.includes(b);

  //     // If one is selected and the other isn't, prioritize the selected one
  //     if (aSelected && !bSelected) return -1;
  //     if (!aSelected && bSelected) return 1;

  //     // If both have the same selection status, sort alphabetically
  //     // Assuming your option object has a 'label' property for display
  //     const aLabel = a.label || a; // Handle both object and string options
  //     const bLabel = b.label || b;

  //     return aLabel.localeCompare(bLabel);
  //   });
  // };

  // const sortOptionsWithSelectedFirst = (
  //   options,
  //   selectedValues,
  //   isOptionAnObj = false
  // ) => {
  //   return [...options].sort((a, b) => {
  //     let aSelected, bSelected, aLabel, bLabel;

  //     // // Detect if we're working with objects or strings
  //     // const isObjectArray =
  //     //   typeof options[0] === "object" && options[0] !== null;

  //     if (isOptionAnObj) {
  //       // Handle object arrays
  //       const selectedLabels = selectedValues.map((item) => item.id);
  //       aSelected = selectedLabels.includes(a.label);
  //       bSelected = selectedLabels.includes(b.label);
  //       aLabel = a.label;
  //       bLabel = b.label;
  //     } else {
  //       // Handle string arrays
  //       aSelected = selectedValues.includes(a);
  //       bSelected = selectedValues.includes(b);
  //       aLabel = a;
  //       bLabel = b;
  //     }

  //     // Prioritize selected items
  //     if (aSelected && !bSelected) return -1;
  //     if (!aSelected && bSelected) return 1;

  //     // Sort alphabetically within groups
  //     return aLabel.localeCompare(bLabel);
  //   });
  // };

  /** -------------------------------------------API----------------------------------------------------------- */
  useEffect(() => {
    const isSimulation = location.state?.fromSimulation === true;

    const fetchSimulationData = async () => {
      if (isSimulation) {
        // console.log("simulazione attiva");
        const simulationData = await loadSimulationData();
        if (simulationData) {
          setUserData(simulationData);
        }
      }
    };
    fetchSimulationData();
    if (!isSimulation) {
      const fetchUser = async () => {
        setLoading(true);
        try {
          const data = await hrGetUserManager(
            // selectedDate,
            // selectedCountry || "",
            // selectedLegalEntity || "",
            // selectedManager || "",
            // selectedJobFunction || "",
            // selectedJobFamily || "",
            // selectedGrade || "",
            // selectedPersonTypes || "",
            // selectedWorkerTypes || "",
            // selectedDepartment || "",
            // selectedCeoLevel || ""
            selectedDate,
            selectedCountry.length > 0 ? selectedCountry.join(",") : "",
            selectedLegalEntity.length > 0 ? selectedLegalEntity.join(",") : "",
            selectedManager.length > 0 ? selectedManager.join(",") : "",
            selectedJobFunction.length > 0 ? selectedJobFunction.join(",") : "",
            selectedJobFamily.length > 0 ? selectedJobFamily.join(",") : "",
            selectedGrade.length > 0 ? selectedGrade.join(",") : "",
            selectedPersonTypes.length > 0 ? selectedPersonTypes.join(",") : "",
            selectedWorkerTypes.length > 0 ? selectedWorkerTypes.join(",") : "",
            selectedDepartment.length > 0 ? selectedDepartment.join(",") : "",
            selectedCeoLevel.length > 0 ? selectedCeoLevel.join(",") : ""
          );
          setUserData(data);
          await saveOrgData(data);
          // localStorage.setItem("orgData", []); //ogni volta che effettuo il refresh della pagina svuoto la cache
          // localStorage.setItem("period", dayjs(userData[0].period, "YYYYMMDD").format("DD/MM/YYYY"));
          // console.log("simulazione non attiva");
        } catch (error) {
          console.error("errore nell'api", error);
          if (error.message?.includes("circular structure")) {
            setErrorMotivation("struttura dati non supportata");
          } else if (error.message?.includes("missing")) {
            setErrorMotivation(`error: ${error.message}`);
          }
        } finally {
          setLoading(false);
        }
      };

      {
        /**
      setCountries(response.country) //sono le opzioni disponibili

      const handleCountryChange=(event)=>{
        setSelectedCountry(event.target.value);
        const legalEntities=countries[event.target.value];
        setLegalEntity("");
        setLegalEntitiesOptions

      */
      }
      //chiamata api per avere i valori dei filtri
      const fetchFiltersValue = async () => {
        try {
          const data = await hrGetFilters(selectedDate);
          setLegalEntities(data.legal_entities);
          setCountries(Object.keys(data.legal_entities));
          // setCountries(Object.keys(data.legal_entities).sort());
          // setCountries(
          //   sortOptionsWithSelectedFirst(
          //     Object.keys(data.legal_entities),
          //     filters.country,
          //     false
          //   )
          // );
          // setManagers(
          //   data.manager_emails.sort((a, b) =>
          //     a.label > b.label ? 1 : b.label > a.label ? -1 : 0
          //   )
          // );
          setManagers(
            data.manager_emails
            // sortOptionsWithSelectedFirst(
            // data.manager_emails,
            // filters.manager_email,
            // true
            // )
          );
          setPersonTypes(data.person_types);
          setGrades(data.grades);
          setDepartments(data.departments);
          setJobFamilies(data.job_families);
          setJobFunctions(Object.keys(data.job_families));
          setWorkerTypes(data.worker_types);
          setCeoLevels(data.ceo_h_levels);
          setPeriodList(data.periods);
          setLoggedUserData(data.user_data);

          // setPersonTypes(data.person_types.sort());
          // setGrades(data.grades.sort());
          // setDepartments(data.departments.sort());
          // setJobFamilies(data.job_families);
          // setJobFunctions(Object.keys(data.job_families).sort());
          // setWorkerTypes(data.worker_types.sort());
          // setCeoLevels(data.ceo_h_levels.sort());
        } catch (error) {
          console.error("errore nel caricamento value filtri");
        }
      };

      fetchUser();
      fetchFiltersValue();
    }
  }, [location.state, selectedDate]);
  const per = userData?.[0]?.period || "";
  const period = dayjs(per, "YYYYMMDD");

  const handleBotResponse = (response) => {
    setBotResponse(response);
    setFiltersFromBot(true);
    handleSetFiltersFromBotResponse(response);
  };

  const handleLayerSpan = (response) => {
    setLayerSpan(response);
  };

  const handleSearchFilter = async () => {
    setLoading(true);
    try {
      // const selectedCountryString =
      //   selectedCountry.length > 0
      //     ? encodeURIComponent(selectedCountry.join(","))
      //     : "";
      const selectedCountryString =
        selectedCountry.length > 0 ? selectedCountry.join(",") : "";
      const selectedLegalEntityString =
        selectedLegalEntity.length > 0
          ? encodeURIComponent(selectedLegalEntity.join(","))
          : "";
      const selectedManagerString =
        selectedManager.length > 0
          ? encodeURIComponent(
              selectedManager.map((managerObj) => managerObj.email).join(",")
            )
          : "";
      console.log(selectedManagerString);
      const selectedJobFunctionString =
        selectedJobFunction.length > 0
          ? encodeURIComponent(selectedJobFunction.join(","))
          : "";
      const selectedJobFamilyString =
        selectedJobFamily.length > 0
          ? encodeURIComponent(selectedJobFamily.join(","))
          : "";
      const selectedGradeString =
        selectedGrade.length > 0
          ? encodeURIComponent(selectedGrade.join(","))
          : "";
      const selectedPersonTypesString =
        selectedPersonTypes.length > 0
          ? encodeURIComponent(selectedPersonTypes.join(","))
          : "";
      const selectedWorkerTypesString =
        selectedWorkerTypes.length > 0
          ? encodeURIComponent(selectedWorkerTypes.join(","))
          : "";
      const selectedDepartmentString =
        selectedDepartment.length > 0
          ? encodeURIComponent(selectedDepartment.join(","))
          : "";
      const selectedCeoLevelString =
        selectedCeoLevel.length > 0
          ? encodeURIComponent(selectedCeoLevel.join(","))
          : "";

      const data = await hrGetUserManager(
        // selectedDate,
        // selectedCountry.join(",") || "",
        // selectedLegalEntity.join(",") || "",
        // selectedManager.join(",") || "",
        // selectedJobFunction.join(",") || "",
        // selectedJobFamily.join(",") || "",
        // selectedGrade.join(",") || "",
        // selectedPersonTypes.join(",") || "",
        // selectedWorkerTypes.join(",") || "",
        // selectedDepartment.join(",") || "",
        // selectedCeoLevel.join(",") || ""
        selectedDate,
        selectedCountryString,
        selectedLegalEntityString,
        selectedManagerString,
        selectedJobFunctionString,
        selectedJobFamilyString,
        selectedGradeString,
        selectedPersonTypesString,
        selectedWorkerTypesString,
        selectedDepartmentString,
        selectedCeoLevelString
      );
      setUserData(data);

      // localStorage.setItem("orgData", []); //ogni volta che effettuo il refresh della pagina svuoto la cache
      // console.log("simulazione non attiva");
    } catch (error) {
      console.error("errore nell'api", error);
    } finally {
      setLoading(false);
    }
  };

  //   const handleFilterChange = (filterType, value) => { //mutua esclusione
  //   //funzione per gestire il cambiamento dei filtri
  //   setFilters((prevFilters) => ({
  //     ...prevFilters,
  //     [filterType]: value || "",
  //   }));
  // };
  const clean = () => {
    setSelectedCountry([]);
    setSelectedLegalEntity([]);
    setSelectedManager([]);
    setSelectedDepartment([]);
    setSelectedWorkerTypes([]);
    setSelectedPersonTypes([]);
    setSelectedJobFunction([]);
    setSelectedJobFamily([]);
    setSelectedGrade([]);
    setSelectedCeoLevel([]);
  };
  const handleReset = () => {
    clean();
    setFilters({
      country: [],
      legal_entity: [],
      manager_email: [],
      grade: [],
      job_function: [],
      job_family: [],
      person_types: [],
      departments: [],
      worker_types: [],
      ceo_h_levels: [],
    });
    setLayerSpan({
      layer: false,
      span: false,
    });
  };
  const handleFilterChange = (filterType, value) => {
    //funzione per gestire il cambiamento dei filtri
    const newFilters = {
      ...filters, //mantiene gli altri valori
      [filterType]: value || "",
      // //regole di esclusione reciproca tra country e legal_entity
      // ...(filterType === "country" && { legal_entity: "" }),
      // ...(filterType === "legal_entity" && { country: "" }),
      ...(filterType === "country" &&
        value.length === 0 && { legal_entity: [] }), //se azzero country azzero anche legal_entity
      ...(filterType === "job_function" &&
        value.length === 0 && { job_family: [] }),
    };
    console.log("newFilters", newFilters);
    setFilters(newFilters);

    switch (
      filterType //imposto il valore
    ) {
      case "manager_email":
        setSelectedManager(value || []);
        break;
      case "country":
        setSelectedCountry(value || []);
        setSelectedLegalEntity([]);
        setFilters((prevFilters) => ({ ...prevFilters, legal_entity: [] }));
        if (value.length === 0) {
          setSelectedLegalEntity([]); //reset visivo se country è vuoto
        }
        break;
      case "legal_entity":
        setSelectedLegalEntity(value || []);
        break;
      case "grade":
        setSelectedGrade(value || []);
        break;
      case "job_function":
        setSelectedJobFunction(value || []);
        setSelectedJobFamily([]);
        setFilters((prevFilters) => ({ ...prevFilters, job_family: [] }));
        if (value.length === 0) {
          setSelectedJobFamily([]); //reset visivo se job_function è vuoto
        }
        break;
      case "job_family":
        setSelectedJobFamily(value || []);
        break;
      case "departments":
        setSelectedDepartment(value || []);
        break;
      case "worker_types":
        setSelectedWorkerTypes(value || []);
        break;
      case "person_types":
        setSelectedPersonTypes(value || []);
        break;
      case "ceo_h_levels":
        setSelectedCeoLevel(value || []);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (filtersFromBot && botResponse.IS_PERTINENT == true) {
      // if (
      //   selectedCountry !== "" ||
      //   selectedLegalEntity !== "" ||
      //   selectedManager !== "" ||
      //   selectedJobFunction !== "" ||
      //   selectedJobFamily !== "" ||
      //   selectedGrade !== "" ||
      //   selectedPersonTypes !== "" ||
      //   selectedWorkerTypes !== "" ||
      //   selectedDepartment !== "" ||
      //   selectedCeoLevel !== ""
      // )
      {
        handleSearchFilter({
          country: selectedCountry,
          legal_entity: selectedLegalEntity,
          manager_email: selectedManager,
          grade: selectedGrade,
          job_function: selectedJobFunction,
          job_family: selectedJobFamily,
          person_types: selectedPersonTypes,
          departments: selectedDepartment,
          worker_types: selectedWorkerTypes,
          ceo_h_levels: selectedCeoLevel,
        });
        setFiltersFromBot(false);
      }
    }
  }, [
    selectedCountry,
    selectedLegalEntity,
    selectedManager,
    selectedGrade,
    selectedJobFunction,
    selectedJobFamily,
    selectedPersonTypes,
    selectedDepartment,
    selectedWorkerTypes,
    selectedCeoLevel,
    filtersFromBot,
  ]);

  const handleSetFiltersFromBotResponse = (filters) => {
    if (!filters) return;

    const keyMapping = {
      job_function: "job_function",
      manager_email: "manager_email",
      legal_entity: "legal_entity",
      country: "country",
      grade: "grade",
      job_family: "job_family",
      department: "departments",
      worker_type: "worker_types",
      person_type: "person_types",
      ceo_h_level: "ceo_h_levels",
    };

    console.log("Original Filters before BOT response: ", filters);
    const updatedFilters = { ...filters };

    Object.entries(filters).forEach(([botKey, value]) => {
      const filterKey = keyMapping[botKey];
      if (!filterKey) return;
      let cleanValue = value ? [value] : [];
      if (value && filterKey === "manager_email") {
        cleanValue = managers.filter((manager) => manager.email === value);
      }
      handleFilterChange(filterKey, cleanValue);
      updatedFilters[filterKey] = cleanValue;
    });
    console.log("Update Filters from Bot: ", updatedFilters);
    setFilters(updatedFilters); //aggiornamento filtri modal
    // handleFilterChange("country", filters.country ?? "");
    // handleFilterChange("ceo_h_levels", filters.ceo_h_level ?? "");
    // handleFilterChange("person_type", filters.person_types ?? "");
    // handleFilterChange("job_function", filters.job_function ?? "");
    // handleFilterChange("job_family", filters.job_family ?? "");
    // handleFilterChange("grade", filters.grade ?? "");
    // handleFilterChange("manager_email", manager_email.country ?? "");
    // handleFilterChange("legal_entity", filters.legal_entity ?? "");
    // handleFilterChange("department", filters.department ?? "");
  };

  const filterData = (data, filters) => {
    if (!data) return [];

    let filteredNodes = data.filter((node) => {
      const matchesCountry =
        !filters.country || node.location === filters.country;
      const matchesRole =
        !filters.legal_entity || node.positionName === filters.legal_entity;
      return matchesCountry && matchesRole;
    });

    return data;
  };

  const formatDateForAPI = (date) => dayjs(date).format("YYYY-MM");

  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    }
  }
  const browser = getBrowserName();
  useEffect(() => {
    if (browser === "Firefox") {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "auto";
      };
    }
  }, []);
  const [tableHeight, setTableHeight] = useState(0);
  useEffect(() => {
    const updateHeight = () => {
      const navbarHeight = document.getElementById("navbar");
      const footerHeight = document.getElementById("footer");
      const availableHeight =
        document.documentElement.clientHeight -
        navbarHeight -
        footerHeight -
        90;
      setTableHeight(availableHeight);
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const handleFit = (event) => {
    event.preventDefault();
    if (chartRef.current) {
      chartRef.current.fit(event);
    }
  };

  /* -------------------------------------------------------- RENDER -------------------------------------------*/
  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
          setProfile={setProfile}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{ p: 2, maxHeight: `${tableHeight}px` }}>
              <Card
                sx={{
                  p: 3,
                  maxHeight: `${tableHeight}px`,
                }}
              >
                <Stack
                  display="flex"
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap" //consente di andare a capo su schermi piccoli
                  rowGap={2} //gap tra le righe (necessario per schermi piccoli)
                  gap={0.5}
                >
                  <Box display="flex" gap={2} alignItems="center">
                    <Button
                      onClick={() => setFilterModalOpen(true)}
                      disabled={isSimulation}
                      size="large"
                      endIcon={<FilterList />}
                      sx={{
                        color: "#00449e",
                        "&:hover": {
                          color: "#00449e",
                        },
                        "&:focus:not(:hover)": {
                          color: "#00449e",
                        },
                        fontSize: "16px",
                      }}
                    >
                      {I18n.get("Filters")}
                    </Button>
                  </Box>

                  {layerSpan.layer || layerSpan.span ? (
                    <Box
                      display="flex"
                      flexDirection="row"
                      gap={2}
                      alignItems="center"
                      sx={{
                        border: "1px solid #6691c4",
                        padding: "0.4rem",
                        borderRadius: "1rem",
                        fontSize: "18px",
                        boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.15)",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          fontWeight="bold"
                          fontSize="18px"
                          color="#00449e"
                        >
                          Layer:
                        </Typography>
                        <CheckCircleOutlineIcon style={{ fill: "#317B22" }} />{" "}
                        {I18n.get("Ideal")}
                        <ErrorOutlineIcon style={{ fill: "#EA3546" }} />{" "}
                        {I18n.get("Threshold exceeded")}
                      </Box>
                      <Divider orientation="vertical" />
                      <Box
                        sx={{
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          fontWeight="bold"
                          fontSize="18px"
                          color="#00449e"
                        >
                          Span:
                        </Typography>
                        <CircleIcon style={{ fill: "#317B22" }} />{" "}
                        {I18n.get("Ideal")}
                        <CircleIcon style={{ fill: "#DE9502" }} />{" "}
                        {I18n.get("Borderline")}
                        <CircleIcon style={{ fill: "#EA3546" }} />{" "}
                        {I18n.get("Threshold exceeded")}
                      </Box>
                    </Box>
                  ) : null}
                  <Box display="flex" gap={2} alignItems={"center"}>
                    <Typography sx={{ marginTop: "16px", fontSize: "14px" }}>
                      {I18n.get("Last update: ")}
                      {(() => {
                        if (!per) return "-";
                        if (!period.isValid())
                          return <CircularProgress size={"12px"} />;
                        return period.format("DD/MM/YYYY");
                      })()}
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Select date"
                        value={dayjs(selectedDate)}
                        format="DD/MM/YYYY"
                        views={["year", "month", "day"]} //mostro solo mese e anno
                        onChange={(newDate) =>
                          setSelectedDate(dayjs(newDate).format("YYYY-MM-DD"))
                        }
                        renderInput={(params) => <TextField {...params} />}
                        minDate={dayjs(periodList[0] ?? "19000101", "YYYYMMDD")}
                        disableFuture
                        sx={{
                          "& .MuiInputBase-input": {
                            padding: "12px 0px  12px  12px  ",
                          },
                          maxWidth: "200px",
                          marginTop: "16px",
                        }}
                        disabled={isSimulation}
                      />
                    </LocalizationProvider>
                  </Box>
                </Stack>
                <Divider sx={{ marginBottom: 0 }} />

                {/** grafico statico */}

                {isSimulation ? (
                  loading ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      height={tableHeight}
                      justifyContent="center"
                    >
                      <CircularProgress />
                    </Box>
                  ) : userData.length === 0 ? (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: tableHeight,
                      }}
                    >
                      <Typography textAlign="center">
                        {I18n.get(
                          "No data is available, or you do not have the required permissions to view this content."
                        )}
                      </Typography>
                    </Box>
                  ) : (
                    <ChartFromSimulation
                      ref={chartRef}
                      data={userData}
                      simulationId={simulationId}
                      period={period}
                      // loggedUserId={"3"}
                    />
                  )
                ) : //non siamo in simulazione

                loading ? (
                  <Box
                    display="flex"
                    alignItems="center"
                    height={tableHeight}
                    justifyContent="center"
                  >
                    <CircularProgress />
                  </Box>
                ) : userData.length === 0 ? (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: tableHeight,
                    }}
                  >
                    <Typography textAlign="center">
                      {I18n.get(
                        "No data is available, or you do not have the required permissions to view this content."
                      )}
                    </Typography>
                  </Box>
                ) : (
                  <OrganizationalChart
                    ref={chartRef}
                    data={userData}
                    period={period}
                    layerSpan={layerSpan}
                    loggedUserData={loggedUserData}
                    // loggedUserId={"3"}
                  />
                )}
                <FilterModal
                  open={filterModalOpen}
                  onClose={() => setFilterModalOpen(false)}
                  onSubmit={handleSearchFilter}
                  filters={filters}
                  handleFilterChange={handleFilterChange}
                  countries={countries}
                  managers={managers}
                  ceoLevels={ceoLevels}
                  personTypes={personTypes}
                  legalEntitiesOptions={legalEntitiesOptions}
                  grades={grades}
                  departments={departments}
                  workerTypes={workerTypes}
                  jobFunctions={jobFunctions}
                  jobFamiliesOptions={jobFamiliesOptions}
                  isSimulation={isSimulation}
                  resetFilter={handleReset}
                />
              </Card>
            </Box>
          </Grid>
        </Grid>
      </DashboardLayout>
      {!isSimulation && (
        <Chat
          onBotResponse={handleBotResponse}
          isMinimized={filterModalOpen || isMinimized}
          setIsMinimized={setIsMinimized}
          handleLayerSpan={handleLayerSpan}
          layerSpan={layerSpan}
          setLayerSpan={setLayerSpan}
        />
      )}

      {/* {layerSpan.layer || layerSpan.span ? (
        <Draggable>
          <Box
            sx={{
              position: "fixed",
              bottom: "3%",
              left: "1.9%",
              maxWidth: "320px",
              backgroundColor: "#f9fafb",
              padding: "10px",
              borderRadius: "1rem",
              // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.15)",
              zIndex: 1200,
              fontSize: "17px",
              border: "1px solid #00449e",
              cursor: "move",
            }}
          >
            <Box
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#00449e",
              }}
            >
              <p id="draggable-title">Information about Layer & Span</p>
            </Box>
            <Box>
              <Box style={{ color: "#6691c4" }}>
                <p>
                  <CheckCircleOutlineIcon style={{ fill: "#317B22" }} />{" "}
                  {I18n.get("The layer is ideal")}
                </p>
                <p>
                  <ErrorOutlineIcon style={{ fill: "#EA3546" }} />{" "}
                  {I18n.get("The layer threshold is exceeded")}
                </p>
              </Box>
              <Divider sx={{ marginBottom: 0.5, marginTop: 0.5 }} />
              <Box style={{ color: "#6691c4" }}>
                <p>
                  <CircleIcon style={{ fill: "#317B22" }} />{" "}
                  {I18n.get("The span is ideal")}
                </p>
                <p>
                  <CircleIcon style={{ fill: "#DE9502" }} />{" "}
                  {I18n.get("The span is borderline")}
                </p>
                <p>
                  <CircleIcon style={{ fill: "#EA3546" }} />{" "}
                  {I18n.get("The span threshold is exceeded")}
                </p>
              </Box>
            </Box>
          </Box>
        </Draggable>
      ) : null} */}
    </>
  );
}

export default Dashboard;
